export class UserModel {
  constructor(o: UserModel) {
    this.id = o.id;
    this.roleID = o.roleID;
    this.roleName = o.roleName;
    this.defaultOrgID = o.defaultOrgID;
    this.defaultOrgName = o.defaultOrgName;
    this.firstName = o.firstName;
    this.lastName = o.lastName;
    this.email = o.email;
    this.allowedLocations = o.allowedLocations;
    this.rptFeatures = o.rptFeatures;
    this.appFeatures = o.appFeatures;
    this.state = o.state;
    this.lastModDate = o.lastModDate;
    this.createDate = o.createDate;
    this.externalID = o.externalID;
  }

  id: string;
  roleID: number;
  roleName: string;
  defaultOrgID: string;
  defaultOrgName: string;
  firstName: string;
  lastName: string;
  email: string;
  allowedLocations: string[];
  rptFeatures: string;
  appFeatures: string;
  state: string;
  lastModDate: Date;
  createDate: Date;
  externalID: string;

  get active(): boolean {
    return this.state === 'A';
  }

  set active(value: boolean) {
    this.state = value ? 'A' : 'R';
  }
}
